import { render } from "./AddTableauIMDGModal.vue?vue&type=template&id=479a6122&ts=true"
import script from "./AddTableauIMDGModal.vue?vue&type=script&lang=ts"
export * from "./AddTableauIMDGModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__